import React, { useState } from 'react'
import { Cell, DataBlock, Divider, Expander, ExpanderContent, ExpanderHeader, Grid, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function OdmRecordSubmitter({ submitter }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  const name = submitter?.name?.value || '--'
  const phone = submitter?.phoneNumbers?.[0]?.value || '--'
  const email = submitter?.emails?.[0]?.value || '--'
  const birth = submitter?.customTags?.[0]?.value || '--'
  const memberRec = submitter?.recIdNumber?.value || '--'
  const addr1 = submitter?.address?.addr1?.value || '--'
  const addr2 = submitter?.address?.addr2?.value || '--'

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.submitter', 'Submitter')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Divider marginY="nano" />
          {submitter && (
            <Grid>
              <Cell columns={2}>
                <DataBlock heading={t('odm.submitter.name', 'Name')} data={name} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.submitter.address', 'Address')} data={<>{`${addr1}, ${addr2}`}</>} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.submitter.phone', 'Phone')} data={phone} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.submitter.email', 'Email')} data={email} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.submitter.birthdate', 'Birthdate')} data={birth} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.submitter.recordNumber', 'Record Number')} data={memberRec} />
              </Cell>
            </Grid>
          )}
          {!submitter && <p>{t('odm.noSubmitter', 'No Submitter Information')}</p>}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
